// extracted by mini-css-extract-plugin
export default {"container":"CreateJobAttachment_container__asJqO"};